import ProductCard from './ProductCard';

// We spotted an issue with small screens, like 358px (sony experia xz2 prem), card looks ugly :(
// This component fixes the issue
export function ProductCardUniversal (props: Parameters<typeof ProductCard>[0]) {
  const propsClassName = props.className ? props.className : '';
  const className = `${propsClassName} w-[350px] sm:w-full`;
  return <ProductCard {...props} className={className} />;
}
